<div class="modal-header">
    <div class=" modal-logo">
      <app-branding-logo-display></app-branding-logo-display>
    </div>
      <h4 class="modal-title mt-4">
        {{ userData.name }}
      </h4>
  <button type="button" class="btn btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')"></button>
</div>
<div class="modal-body">
  @if(menuMode === 'home'){
    <ul class="list-unstyled">
      <li class="btn btn-secondary w-100" (click)="setMenuMode('changePassword')">
        <ng-icon size="1em" name="bootstrapPersonBadge"></ng-icon>
        Change Password
      </li>
    </ul>
  }

  @if(menuMode === 'changePassword'){
    <app-change-password-form (backHome)="setBackToHome()"></app-change-password-form>
  }

</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-secondary" (click)="activeModal.close('Close click')">Close</button>
</div>
